import Vue from 'vue'
import Vuex from 'vuex'
import * as sessionState from './SessionState.js'
import * as commercialState from './CommercialState.js'
import * as trackedState from './TrackedState.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {



  },
  mutations: {
  },
  actions: {
  },
  modules: {
    sessionState : sessionState.SessionState,
    commercialState : commercialState.CommercialState,
    trackedState : trackedState.TrackedState
  }
})
